import { useTranslation } from 'react-i18next';
import { Modal } from '../ui/Modal';

interface EditLockedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleteAndCopy: () => void;
  onCopyKeepActive: () => void;
  /** Which lock was tapped. `methods`: pickup/drop-off, fixed from publish
   *  whether or not anyone has ordered; the default copy blames orders. */
  reason?: 'orders' | 'methods';
}

/**
 * Shown when a lister taps a locked field on an active listing that has orders.
 * Surfaces the only two safe next steps: cancel the original and start a copy,
 * or leave the original active and start a copy alongside it.
 */
export const EditLockedModal: React.FC<EditLockedModalProps> = ({
  isOpen,
  onClose,
  onDeleteAndCopy,
  onCopyKeepActive,
  reason = 'orders',
}) => {
  const { t } = useTranslation('publish');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <h3 className="text-lg font-bold mb-4 pr-8">{t('editLocked.title')}</h3>

      <p className="text-sm text-muted-foreground mb-6">
        {t(reason === 'methods' ? 'editLocked.bodyMethods' : 'editLocked.body')}
      </p>

      <div className="flex flex-col gap-2">
        <button
          type="button"
          onClick={onDeleteAndCopy}
          className="w-full rounded-lg bg-brand-primary py-2.5 text-sm font-semibold text-white active:opacity-80"
        >
          {t('editLocked.deleteAndCopy')}
        </button>
        <button
          type="button"
          onClick={onCopyKeepActive}
          className="w-full rounded-lg btn-outline border-border py-2.5 text-sm font-semibold text-foreground active:opacity-80"
        >
          {t('editLocked.copyKeepActive')}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="w-full rounded-lg py-2.5 text-sm font-medium text-muted-foreground active:opacity-80"
        >
          {t('editLocked.neverMind')}
        </button>
      </div>
    </Modal>
  );
};
